var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Icon - Reload",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04 8.026l3 4.5 3.5-4",
    "data-name": "Path 5309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.079 12.683A10.473 10.473 0 0114.155.758a10.446 10.446 0 0110.878 9.977 10.421 10.421 0 01-10.106 10.737 10.539 10.539 0 01-7.549-2.782",
    "data-name": "Path 5310"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdib3g9IjAgMCAyNiAyNCI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGRhdGEtbmFtZT0iSWNvbiAtIFJlbG9hZCIgb3BhY2l0eT0iLjUiPjxwYXRoIGQ9Im0xLjA0IDguMDI2IDMgNC41IDMuNS00IiBkYXRhLW5hbWU9IlBhdGggNTMwOSIvPjxwYXRoIGQ9Ik00LjA3OSAxMi42ODNBMTAuNDczIDEwLjQ3MyAwIDAgMSAxNC4xNTUuNzU4YTEwLjQ0NiAxMC40NDYgMCAwIDEgMTAuODc4IDkuOTc3IDEwLjQyMSAxMC40MjEgMCAwIDEtMTAuMTA2IDEwLjczNyAxMC41MzkgMTAuNTM5IDAgMCAxLTcuNTQ5LTIuNzgyIiBkYXRhLW5hbWU9IlBhdGggNTMxMCIvPjwvZz48L3N2Zz4K";
export { SvgReloadIcon as ReactComponent };